var _circle, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 890.9,
    cy: 334.4,
    r: 32.6,
    fill: "#35A4DD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#F9AF17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.5 36.2v667.5M710.4 503.7L495.5 704.5M280.6 503.7l214.9 200.8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35A4DD",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M629.2 334.4h166.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35A4DD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M361 334.4H100.5v653.4h790.4V421.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadDown);
export default ForwardRef;